import React from "react";
import { formatToken } from "../../utils/format";
import { TOKEN_SYMBOL } from "../../config/config";
import "./IncomeCard.css";

export default function IncomeCard({ label, totalEarned, pendingAmount, onClaim, claimLabel, loading, color }) {
  return (
    <div className="inc-card" style={{ "--inc-color": color || "#00f0ff" }}>
      <div className="inc-card-header">
        <span className="inc-card-label">{label}</span>
      </div>
      <div className="inc-card-value">{formatToken(totalEarned)} {TOKEN_SYMBOL}</div>
      {pendingAmount && !pendingAmount.isZero() && (
        <div className="inc-card-pending">
          Pending: {formatToken(pendingAmount)} {TOKEN_SYMBOL}
        </div>
      )}
      {onClaim && (
        <button
          className="inc-card-btn"
          onClick={onClaim}
          disabled={loading}
        >
          {loading ? "Processing..." : claimLabel || "Claim"}
        </button>
      )}
    </div>
  );
}
